<app-nav-bar></app-nav-bar>
<section class="icon-menu">
    <i class="fa fa-2x fas fa-th-large" (click)="statusTopNav($event)"></i>
</section>
<router-outlet></router-outlet>